module.exports = __webpack_public_path__ + "static/abdullateef-c63990c897122ee430d47076dc30ad27.jpg";